import { render, staticRenderFns } from "./Reloj.vue?vue&type=template&id=80c5f7b8&scoped=true&"
import script from "./Reloj.vue?vue&type=script&lang=js&"
export * from "./Reloj.vue?vue&type=script&lang=js&"
import style0 from "./Reloj.vue?vue&type=style&index=0&id=80c5f7b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c5f7b8",
  null
  
)

export default component.exports